// This is the limit of the range that can be passed when fetching a transcript.
export const MAX_TRANSCRIPT_RANGE_IN_MS = 5 * 60 * 1000; // 5 minutes
